import React, { useRef, useState } from 'react'
import PropTypes from 'prop-types'
import Dropzone from 'react-dropzone'
import { connect } from 'react-redux'
import { change } from 'redux-form'
import * as uploadTypes from 'actions/uploader/types'

const Attachment = ({
  input,
  label,
  acceptedFiles = 'image/gif, image/jpeg, image/png',
  multipleUpload,
  formName,
  dispatch,
  getStatus,
}) => {
  const maxUpload = 7
  const dropZone = useRef()
  const [processing, setProcessing] = useState(false)

  const handleFileChange = async (files) => {
    setProcessing(true)
    getStatus && getStatus(true)
    const arrFiles = Array.from(files)
    formName &&
      dispatch(
        change(
          formName,
          input.name,
          arrFiles.map((f, i) => ({ name: f.name, order: i, type: f.type }))
        )
      )
    const results = await multipleUpload({ files, max: maxUpload })
    const uploadedFiles = results.map((result, index) => ({
      path: result.path,
      name: result.name,
      order: result.index,
      type: files[index].type,
    }))
    formName && dispatch(change(formName, input.name, uploadedFiles))
    getStatus && getStatus(false)
    setProcessing(false)
  }
  return (
    <div className="attachment text-gray-500">
      <Dropzone
        name={input.name}
        accept={acceptedFiles}
        ref={dropZone}
        disabled={processing}
        onDrop={(files) => handleFileChange(files)}
        className="hidden"
        multiple={true}
      >
        {({ getRootProps, getInputProps, isDragReject }) => (
          <section>
            <div className="py-3 mr-3 focus:outline-none flex items-center" {...getRootProps()}>
              {!isDragReject && (
                <>
                  <i className="fa fa-paperclip mr-2" />
                  {label}
                </>
              )}
              {isDragReject && (
                <div className="text-action-danger pointer-events-none flex items-center">
                  <i className="fa fa-3x fa-ban mr-2" aria-hidden="true"></i>
                  <span>{`The file format doesn't seem to be allowed.`}</span>
                </div>
              )}
              <input {...getInputProps()} />
            </div>
          </section>
        )}
      </Dropzone>
    </div>
  )
}

Attachment.propTypes = {
  input: PropTypes.object.isRequired,
  label: PropTypes.string,
  acceptedFiles: PropTypes.string,
  multipleUpload: PropTypes.func,
  formName: PropTypes.string,
  dispatch: PropTypes.func,
  getStatus: PropTypes.func,
}

const mapDispatchToProps = (dispatch) => ({
  multipleUpload: (payload) =>
    new Promise((resolve, reject) => {
      dispatch({ type: uploadTypes.MULTIPLE_UPLOAD, payload, resolve, reject })
    }),
  dispatch,
})

export default connect(null, mapDispatchToProps)(Attachment)
